/**
 * Constants for SignalR service configuration and events
 */
export const SignalRConstants = {
  HUB_URL: 'hubs/notification',

  Events: {
    Connected: 'Connected',
    JoinedGroup: 'JoinedGroup',
    LeftGroup: 'LeftGroup',
    ConnectionClosed: 'ConnectionClosed',
    Update: 'Update',
    Heartbeat: 'Heartbeat'
  },

  Groups: {
    TROUBLESHOOTING: 'troubleshooting',

    // Helper method for creating troubleshooting group names
    Troubleshooting: (subscriberNumber) => `troubleshooting_${subscriberNumber}`,
  },

  // Connection states for better status tracking
  ConnectionStates: {
    DISCONNECTED: 'Disconnected',
    CONNECTING: 'Connecting',
    CONNECTED: 'Connected',
    DISCONNECTING: 'Disconnecting',
    RECONNECTING: 'Reconnecting'
  },

  // Log levels for consistent logging
  LogLevels: {
    TRACE: 'TRACE',
    DEBUG: 'DEBUG',
    INFO: 'INFO',
    WARN: 'WARN',
    ERROR: 'ERROR'
  }
};

export default SignalRConstants;
